import { Validator, FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PasswordMatchValidator implements Validator {
	validate(formGroup: FormGroup) {
		const { newPassword, newPasswordRepeated } = formGroup.value;

		if (newPassword === newPasswordRepeated) {
			return null;
		} else {
			return { noMatchingPassword: true };
		}
	}
}
